import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tpc-fleet',
  templateUrl: './fleet.component.html',
  styleUrls: ['./fleet.component.css']
})
export class FleetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/fleet/fleet.component.ts